import { Dialog, DialogBackdrop, DialogPanel, Textarea } from "@headlessui/react";
import { Close } from "../../assets/icons";
import ButtonGroup from "../common/button-group";
import { caseDetailsPayload } from "../../models/Myprojects";
import { ChangeEvent, useEffect, useState } from "react";
import Button from "../common/text-button-group";
import { LABELS } from "../../constants/labels/jetlift/jetlift.labels";

const closeButtonOptions = [
    { id: 1, icon: "", label: "Cancel", type: "secondary", className: 'px-3' }
];
const saveButtonOptions = [
    { id: 2, icon: "", label: "Save", type: "primary", className: 'px-4' }
];

const CaseDialog: React.FC<{ show: boolean, mode: 'create' | 'update', caseDetails?: caseDetailsPayload, close?: (payload?: caseDetailsPayload) => void, showDesignType?: boolean, designButtonOptions?: any }> = ({
    show = false,
    mode = 'create',
    caseDetails,
    close = (payload?: caseDetailsPayload) => { },
    showDesignType = false,
    designButtonOptions,
}) => {
    const [caseName, setCaseName] = useState('');
    const [caseDescription, setCaseDescription] = useState('');
    const [liftType, setLiftType] = useState('ESP');
    const [errors, setErrors] = useState<{ [key: string]: string }>({});

    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        let errorMessage = "";

        if (name === "caseName" && value.trim().length < 1) {
            errorMessage = "case name is required";
        }

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: errorMessage,
        }));
    };

    useEffect(() => {
        setErrors({});
        if (mode === 'update') {
            setCaseName(caseDetails?.caseName || '');
            setCaseDescription(caseDetails?.caseDescription || '');
            setLiftType(caseDetails?.liftType?.toString() === "2" ? 'Jet lift' : 'ESP');
        } else {
            setCaseName('');
            setCaseDescription('');
            setLiftType('ESP');
        }

    }, [caseDetails, mode])

    const handleClose = () => {
        if (mode === "create") {
            setCaseName("");
            setCaseDescription("");
        };
        setErrors({});
        close();
    }

    return (
        <Dialog open={show} onClose={() => handleClose()} className="relative z-[1002]">
            <DialogBackdrop
                transition
                className="fixed inset-0 backdrop-blur-sm transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />
            <div className="fixed inset-0 z-10 w-screen">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <DialogPanel
                        transition
                        className="flex dialog-max-height relative transform overflow-hidden rounded-lg border-[2px] border-darkcolor-400 bg-darkcolor-700 text-neutral-25 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-sm md:min-w-[486px] md:w-[486px]  data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                    >
                        <div className="flex flex-col w-full ">
                            <div className="border-b-[2px] border-darkcolor-400 py-5 px-6">
                                <div className="flex flex-row justify-between text-neutral-25">
                                    <div>
                                        <div className="text-[19px] font-semibold">{mode === 'create' ? 'Add new case' : 'Modify case details'}</div>
                                    </div>
                                    <a href="javascript:void(0)" onClick={() => handleClose()}>
                                        <Close />
                                    </a>
                                </div>
                            </div>
                            <div className="p-6 w-full flex flex-col overflow-y-auto py-5 px-6 gap-3  border-b-[2px] border-darkcolor-400">
                                <div className="flex flex-col items-start">
                                    <label className="text-[14px] text-neutral-25 mb-[6px]">
                                        Case name <span className="text-error-400">*</span>
                                    </label>
                                    <input
                                        placeholder="Enter case name"
                                        required={true}
                                        value={caseName}
                                        onBlur={handleBlur}
                                        onChange={(e: ChangeEvent<HTMLInputElement>) => setCaseName(e.target.value)}
                                        name="caseName"
                                        maxLength={50}
                                        className="flex px-[12px] py-[10px] rounded-[8px] border-[1px] border-darkcolor-400 w-full bg-transparent text-neutral-25 focus:outline-none text-[16px]"
                                    />
                                    {errors.caseName && (
                                        <div className="text-error-700 text-sm mt-1 w-full">
                                            {errors.caseName}
                                        </div>
                                    )}
                                </div>
                                {showDesignType && (
                                    <div className="flex flex-col items-start w-full bg-transparent text-neutral-25 focus:outline-none text-[16px]">
                                        <Button label={LABELS?.chooseDesignType}
                                            required
                                            buttonOptions={designButtonOptions?.length > 0 ? designButtonOptions : []}
                                            unit={liftType}
                                            handleClick={(e) => { setLiftType(e); }} width={""} />
                                    </div>
                                )}
                                <div className="flex flex-col items-start w-full bg-transparent text-neutral-25 focus:outline-none text-[16px]">
                                    <label className="text-[14px] text-neutral-25 mb-[6px]">
                                        Case description
                                    </label>
                                    <textarea
                                        placeholder="Enter here"
                                        required={true}
                                        value={caseDescription}
                                        rows={2}
                                        onChange={(e: ChangeEvent<HTMLTextAreaElement>) => setCaseDescription(e.target.value)}
                                        name="caseDescription"
                                        className="flex px-[12px] py-[10px] rounded-[8px] border-[1px] border-darkcolor-400 w-full bg-transparent text-neutral-25 focus:outline-none text-[16px] hover:border-primary-500 focus:ring-primary-500 focus-within:ring-1 focus-within:border-primary-500"
                                    />
                                </div>
                            </div>
                            <div className="flex-row flex gap-3 border-top justify-end items-center py-3 px-6">
                                <ButtonGroup
                                    buttonOptions={closeButtonOptions}
                                    handleClick={() => handleClose()}
                                />
                                <ButtonGroup
                                    buttonOptions={saveButtonOptions}
                                    handleClick={() => close({ caseName, caseDescription, liftType, caseModalMode: mode })}
                                    disabled={!(caseName && caseName.trim())}
                                />
                            </div>
                        </div>
                    </DialogPanel>
                </div>
            </div>
        </Dialog>

    );
}

export default CaseDialog;
